import { DnDStageMapping } from '@forwardflow/features'
import { useGetStageMapping } from '@forwardflow/queries/stage-mapping.queries'
import { StageMappingService } from '@forwardflow/services/stage-mapping.service'
import { IStageMapGroup } from '@forwardflow/types/onboarding'

const StageMapping = () => {
   const { data: stageMapping } = useGetStageMapping()

   return (
      <div className="flex flex-col flex-1">
         <div className="flex items-center justify-between p-4 pt-6">
            <p className="text-2xl font-medium text-white">Stage mapping</p>
         </div>

         <div className="flex flex-col pb-10 pr-5 gap-y-6">
            <DnDStageMapping
               initialStageMappingGroups={stageMapping || []}
               onSaveStageMappingGroups={(groups) => {
                  StageMappingService.updateStageMapping({ stageMapping: groups as IStageMapGroup[] })
               }}
               autoSave
               showNavigation={false}
            />
         </div>
      </div>
   )
}

export default StageMapping
